module.exports = FormData;


//////////////////
// WEBPACK FOOTER
// ../js/~/isomorphic-form-data/lib/browser.js
// module id = 640
// module chunks = 0